import { render, staticRenderFns } from "./jsonModal.vue?vue&type=template&id=f5bf0b64"
import script from "./jsonModal.vue?vue&type=script&lang=js"
export * from "./jsonModal.vue?vue&type=script&lang=js"
import style0 from "./jsonModal.vue?vue&type=style&index=0&id=f5bf0b64&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports